export const translations = {
  es: {
    about: {
      title: "¿Qué es OverCut?",
      intro: "OverCut es una plataforma completa de Fórmula 1 donde los fans pueden explorar, jugar y aprender mediante herramientas interactivas y estadísticas avanzadas.",

      posts: {
        title: "🗞️ Publicaciones",
        desc: "La sección de los posts siempre se encuenta en la página de inicio de Overcut. Muestra análisis de tendencias actuales o pasadas en la Fórmula 1, columnas de opinión o noticias recientes sobre el deporte."
      },

      quiz: {
        title: "🧠 Quiz",
        desc: "Responde preguntas sobre historia, reglamento, estadísticas y más. Los quizzes se agrupan por categorías y subcategorías, con decenas de temas para todos los niveles.",
        extraDesc: "¡Regístrate y compite con la comunidad acumulando puntos en los quiz! ¡Intenta llegar a lo más alto del ranking!"
      },
      games: {
        title: "🎮 OverCut Games",
        desc: "Diviértete con minijuegos temáticos como:",
        fullDesc: "¡Y muchos más! Cada juego pone a prueba tu conocimiento de la F1 de formas originales e interactivas. ¡Regístrate y prueba tu valía!"
      },


      f1hub: {
        tablesTitle: "OverCutHub - 📋 Sección de Tablas",
        tablesDesc: "Explora los datos crudos y estructurados con una interfaz clara e interactiva. Navega por décadas o filtra cada carrera.",

        sessions: "🏁 1. Resultados por sesión: consulta resultados de cualquier Gran Premio desde 1950, eligiendo año, GP (con país y circuito) y sesión (Carrera, Clasificación, Sprint o Prácticas FP1/FP2/FP3). Cada tipo tiene su tabla adaptada con tiempos, posiciones, abandonos y colores de equipo y nacionalidad.",

        rankings: "🧠 2. Rankings y récords históricos: explora rankings como pilotos con más títulos, victorias, poles o podios, y récords únicos como victorias sin liderar o podios en cumpleaños. Subcategorías: Campeonatos 🏆, Victorias 🏁, Podios 🥉, Puntos 📈, Grandes Premios 🗓️ y Estadísticas especiales 🔍.",

        championship: "📅 3. Seguimiento del Campeonato: visualiza la evolución del campeonato por temporada. Selecciona un año y sigue ronda a ronda los puntos de cada piloto en vista tipo matriz (columnas=carreras, filas=pilotos, celdas=puntos).",

        chartsTitle: "OverCutHub - 📈 Sección de Gráficas",
        chartsDesc: "Convierte datos en visualizaciones intuitivas, atractivas y personalizables. Compara pilotos, equipos o temporadas, filtra por categoría y explora análisis avanzados.",
        chartExamples1: "Evolución de puntos por temporada.",
        chartExamples2: "Porcentaje de podios respecto a compañeros de equipo.",
        chartExamples3: "Posiciones medias de salida y llegada.",
        chartExamples4: "Delta entre clasificación y carrera.",
        chartExamples5: "Podios desde fuera del Top 10, dominancia por circuito, comparaciones entre compañeros, rankings de fiabilidad, adelantamientos y más."
      },

      predictions: {
        intro:
          "OverCut Predictions es el simulador interactivo de campeonatos. Te permite rehacer una temporada desde cualquier ronda y ver cómo cambiaría el mundial si los resultados hubieran sido distintos.",

        feature1:
          "🏁 Elige una temporada real y la ronda desde la que quieres empezar a simular.",

        feature2:
          "🔀 Reordena el resultado de cada Gran Premio moviendo pilotos libremente.",

        feature3:
          "📊 El sistema recalcula en tiempo real las clasificaciones de pilotos y constructores.",

        feature4:
          "🧠 Compatible con calendarios, equipos y pilotos reales cargados desde la base de datos.",

        end:
          "Es la herramienta perfecta para debates, escenarios hipotéticos y análisis del tipo “¿qué habría pasado si…?”"
      },

    }
  },

  en: {
    about: {
      title: "What is OverCut?",
      intro: "OverCut is a complete Formula 1 platform where fans can explore, play and learn with interactive tools and advanced statistics.",

      posts: {
        title: "🗞️ Posts",
        desc: "The posts section is always featured on OverCut's homepage. It presents analyses of current or past Formula 1 trends, opinion columns, or the latest news about the sport."
      },

      quiz: {
        title: "🧠 Quiz",
        desc: "Answer questions about F1 history, regulations, statistics and more. Quizzes are organized by category and subcategory with dozens of topics for all levels.",
        extraDesc: "Register and compete with the community by earning points in the quizzes! Try to climb to the top of the ranking!"
      },
      games: {
        title: "🎮 OverCut Games",
        desc: "Enjoy themed minigames such as:",
        fullDesc: "And many more! Each game tests your F1 knowledge in original and interactive ways. Register and prove your worth!"
      },

      f1hub: {
        tablesTitle: "OverCutHub - 📋 Table Section",
        tablesDesc: "Explore raw and structured data with a clear, interactive interface. Browse decades or focus on individual races.",

        sessions: "🏁 1. Session Results: View complete results of any Grand Prix since 1950 by selecting year, GP (with country/circuit), and session (Race, Qualifying, Sprint or Practice FP1/FP2/FP3). Each type has an adapted table with times, positions, retirements and team/nationality colours.",

        rankings: "🧠 2. Rankings & Records: Browse rankings like most titles, wins, poles or podiums, plus unique records like wins without leading or birthday podiums. Subcategories: Championships 🏆, Wins 🏁, Podiums 🥉, Points 📈, Grand Prix 🗓️ and Special Stats 🔍.",

        championship: "📅 3. Championship Tracking: View the championship evolution per season. Select a year and see race-by-race driver points in a matrix view (columns=races, rows=drivers, cells=points).",

        chartsTitle: "OverCutHub - 📈 Charts Section",
        chartsDesc: "Turn data into intuitive, attractive and customizable visualizations. Compare drivers, teams or seasons, filter by category and explore advanced analyses.",
        chartExamples1: "Points evolution per season.",
        chartExamples2: "Percentage of podiums compared to teammates.",
        chartExamples3: "Average starting and finishing positions.",
        chartExamples4: "Delta between qualifying and race.",
        chartExamples5: "Podiums from outside the Top 10, team dominance by circuit, teammate comparisons, reliability rankings, overtakes and more."
      },

      predictions: {
        intro:
          "OverCut Predictions is an interactive championship simulator. It allows you to replay a season from any round and see how the standings would change if race results had been different.",

        feature1:
          "🏁 Choose a real season and the round from which you want to start simulating.",

        feature2:
          "🔀 Reorder each Grand Prix result by freely rearranging drivers.",

        feature3:
          "📊 The system recalculates drivers’ and constructors’ standings in real time.",

        feature4:
          "🧠 Fully compatible with real calendars, teams and drivers loaded from the database.",

        end:
          "It’s the perfect tool for debates, hypothetical scenarios and classic “what if…?” analyses."
      },

    }
  }
};
